import { Flex, ScreenReaderContent, SimpleSelect, Text } from '@instructure/ui';
import { selectorOptions, shouldShowSelector } from './languageSelection';

// An unknown code shows as the raw code, so a new language works without a label.
const LANGUAGE_LABELS = {
  en: 'English',
  es: 'Español',
};

const labelFor = (code) => LANGUAGE_LABELS[code] ?? code;

// The visible label is outside SimpleSelect: InstUI pads the bottom of its own label,
// which leaves an inline label above the select's center.
const LanguageSelector = ({ availableLanguages, value, onChange }) => {
  const t = window._t;

  return (
    <Flex alignItems="center" gap="x-small">
      <Text aria-hidden="true" size="small" weight="bold">{t('Language')}</Text>
      <SimpleSelect
        renderLabel={<ScreenReaderContent>{t('Language')}</ScreenReaderContent>}
        size="small"
        width="7rem"
        value={value}
        // SimpleSelect fires onChange when the current option is picked again.
        onChange={(_event, { value: code }) => code !== value && onChange(code)}
        data-qa="language-selector"
      >
        {selectorOptions(availableLanguages).map((code) => (
          <SimpleSelect.Option key={code} id={`language-${code}`} value={code}>
            {labelFor(code)}
          </SimpleSelect.Option>
        ))}
      </SimpleSelect>
    </Flex>
  );
};

// Shown in both take and preview.
const languageSelectorElement = (availableLanguages, value, onChange) =>
  shouldShowSelector(availableLanguages) ? (
    <LanguageSelector availableLanguages={availableLanguages} value={value} onChange={onChange} />
  ) : null;

export { LanguageSelector, languageSelectorElement };
